/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"

import { getRequest } from "utils/request"
import "./style.css"
import { useNotification } from "hooks/notification"
import { useAuth } from "hooks/auth"
import { useModal } from "hooks/modal"
import { Tooltip } from "@material-ui/core"
import { putRequest } from "utils/request"
import { makeStyles } from "@material-ui/styles"
import { ImageLoader } from "../ImageLoader"
import { ToggleTopBar } from "components/Header/components/ToggleTopBar"

export default function TopBar({ history }) {
  const [loading, setLoading] = useState(false)
  const [menus, setMenus] = useState([])
  const [openIntegration, setOpenIntegration] = useState("")
  const [channels, setChannels] = useState([])
  const { user, setIsPaused } = useAuth()
  const { selectedCompany, hideTopBar } = useNotification()
  const { toggleModal, helperId, ignoreQr } = useModal()

  const useStyles = makeStyles(() => ({
    customWidth: {
      fontSize: 16,
    },
  }))
  const classes = useStyles()

  async function getData() {
    if (selectedCompany.id >= 0) {
      setLoading(true)

      const openIntegrationResponse = await getRequest(
        `/companies/openintegration/${selectedCompany.id}`
      )
      if (openIntegrationResponse.success) {
        setOpenIntegration(openIntegrationResponse.data.openIntegration)
      }

      const channelsResponse = await getRequest(
        `/companieschannels?CompanyId=${selectedCompany.id}`
      )
      if (channelsResponse.success) {
        setChannels(channelsResponse.data)
      }

      //BUSCA MENUS DISPONIVEIS POR EMPRESA
      const menusResponse = await getRequest(
        `/menus?UserTypeId=${user.UserTypeId}&CompanyId=${selectedCompany.id}`
      )
      if (menusResponse.success) {
        const filteredMenu = menusResponse.data.filter((m) => m.type === "M")
        setMenus(filteredMenu)
      }

      setLoading(false)
    }
  }

  const pauseAttendant = async () => {
    const response = await putRequest(`/users/pauseAttendant`, {
      isPaused: true,
    })

    if (response.success) {
      setIsPaused(true)
      sessionStorage.setItem("@Omni:isPaused", true)
    }
  }

  useEffect(() => {
    getData()
  }, [selectedCompany])

  return (
    <div
      className="container-top-bar"
      style={{
        maxHeight: hideTopBar && 0,
        marginBottom: !hideTopBar && 10,
        position: "relative",
        // zIndex: 100,
      }}
    >
      <ToggleTopBar />

      <div
        className="topnav"
        style={{
          background: "#29B3BD",
          display: "flex",
          flexDirection: "row",
          maxHeight: hideTopBar && 0,
          width: "100%",
        }}
      >
        {!hideTopBar ? (
          <div className="container-fluid">
            <nav className="navbar navbar-dark navbar-expand-lg topnav-menu">
              <ul className="navbar-nav">
                {!loading ? (
                  <>
                    {menus.map((data, index) => (
                      <li
                        className="nav-item dropdown"
                        key={index}
                        onClick={() => {
                          if (data.external) {
                            window.open(data.link)
                          } else {
                            if (data.link !== null) {
                              history.push(
                                `../../../../../dashboard${data.link}`
                              )
                            }
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className="nav-link dropdown-toggle arrow-none"
                          id={`topnav-${index}`}
                        >
                          <i className={data.icon}></i>
                          {data.description}

                          {data.topMenu.length > 0 ? (
                            <div className="arrow-down"></div>
                          ) : (
                            <></>
                          )}
                        </div>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="topnav-apps"
                        >
                          {data.topMenu.length > 0 ? (
                            data.topMenu.map((data, index) => (
                              <li
                                className="dropdown-item"
                                key={index}
                                onClick={() => {
                                  history.push(
                                    `../../../../../dashboard${data.link}`
                                  )
                                }}
                              >
                                {data.description}
                              </li>
                            ))
                          ) : (
                            <></>
                          )}
                        </ul>
                      </li>
                    ))}
                  </>
                ) : (
                  <li className="nav-item dropdown">
                    <div className="nav-link dropdown-toggle arrow-none">
                      <i></i>...
                    </div>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        ) : (
          <div style={{ height: 60 }} />
        )}
        {!hideTopBar && (
          <>
            {/* TODO */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {channels.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginRight: 20,
                  }}
                >
                  <div
                    style={{
                      marginRight: 10,
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    Canais:
                  </div>
                  {channels.map((item) => (
                    <Tooltip
                      arrow
                      classes={{ tooltip: classes.customWidth }}
                      title={
                        item.Channel.description === "Whatsapp QRCODE" &&
                        ignoreQr
                          ? "Whatsapp QRCODE inativo"
                          : item.Channel.description
                      }
                    >
                      <ImageLoader
                        style={{
                          height: 25,
                          marginRight: 10,
                          opacity:
                            item.Channel.description === "Whatsapp QRCODE" &&
                            ignoreQr &&
                            0.3,
                        }}
                        imgUrl={item.Channel.image}
                        resourceType="channel"
                        whosCalling="Topbar 226"
                      />
                    </Tooltip>
                  ))}
                </div>
              )}
              <span
                className="helper-icon"
                onClick={() => toggleModal(helperId)}
                style={{}}
              >
                <i className="far fa-question-circle"></i>
              </span>
            </div>
            {helperId === 6 &&
            (Number(user.UserTypeId === 14) ||
              Number(user.UserTypeId === 15) ||
              Number(user.UserTypeId === 4) ||
              Number(user.UserTypeId === 10)) ? (
              <Tooltip arrow title={"Pausar atendimento"}>
                <span onClick={() => pauseAttendant()} className="helper-icon">
                  <i class="far fa-pause-circle"></i>
                </span>
              </Tooltip>
            ) : (
              <></>
            )}
          </>
        )}
      </div>
    </div>
  )
}
